<template>
  <div id="app">
		<section class="h-header pc-display" :class="headerFixed ? 'header-fixed':''" ref="headerNav">
			<div class="contact-number">
				<div class="container">
					<div class="row"> 
						<div class="col-xs-12 col-sm-12 col-md-12">
							<div class="article-search text-align-right">
								<label style="color:#ffffff;display:inline-block;margin-right:20px">联系电话：010-85181133</label>
								<div class="input-list">
									<input @keyup="searchByArticleTitle()" type="text" placeholder="法律资讯" value="" v-model="searchWords" autocomplete="off" id="searchByIf"/>  <!-- onkeyup="searchByArticleTitle()" -->
									<div @click="searchByArticleTitle()">
										<label class="icon iconfont">&#xe616; </label>
										搜索</div>
									<ul class="search-list productUL" v-show="searchListDisplay">
										<li style="color:#cccccc;" v-if="!searchData.length">没有您要搜索的内容~</li>
										<li v-for="(item, index) of searchData" :key="index" @click="handleToContentDetail(item.id)">{{item.content}}</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="container">
				<div class="row h-nav">
					<div class="col-xs-5 col-sm-3 col-md-5">
						<img src="./assets/img/h-logo.png" alt="体语科技"/>
					</div>
					<div class="col-xs-7 col-sm-8 col-md-7 text-align-center">
						<div class="row" id="clickNav">
							<div v-for="(item, index) of navList" :key="index" class="navitem col-xs-2 col-sm-2 col-md-2">
								<a href="javascript:void(0);" :class="navActiveIndex == index ? 'h-nav-active':''" @click="handleToPage(item.url, index)"><span>{{item.text}}</span></a>
							</div>
						</div>
					</div>
					<!-- <div class="col-xs-1 col-sm-1 col-md-1 text-align-center">
						<a href="javascript:void(0);" class="iconfont">&#xe616;</a>
					</div> -->
				</div>
			</div>
		</section>
		<section class="yidong-display">
			<div class="h-header" :class="headerFixed ? 'header-fixed':''"  ref="headerNav">
				<div class="contact-number">
					<div class="container">
						<div class="row"> 
							<div class="col-xs-12 col-sm-12 col-md-12">
								<div class="article-search text-align-right">
									<label @click="makingACall('010-85181133')" style="color:#ffffff;display:inline-block;margin-right:20px">联系电话：010-85181133</label>
									<div class="input-list">
										<input @keyup="searchByArticleTitle()" type="text" placeholder="法律资讯" value="" v-model="searchWords" autocomplete="off" id="searchByIf"/>  <!-- onkeyup="searchByArticleTitle()" -->
										<div @click="searchByArticleTitle()">
											<span class="icon iconfont">&#xe616; </span>
											<span>搜索</span>
										</div>
										<ul class="search-list productUL" v-show="searchListDisplay">
											<li style="color:#cccccc;" v-if="!searchData.length">没有您要搜索的内容~</li>
											<li v-for="(item, index) of searchData" :key="index" @click="handleToContentDetail(item.id)">{{item.content}}</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="container">
					<div class="row h-nav">
						<div class="col-xs-5 col-sm-5 col-md-5">
							<img src="./assets/img/h-logo.png" class="yd-logo" alt="体语科技"/>
						</div>
						<div class="col-xs-7 col-sm-7 col-md-7 text-align-right show-nav-text" @click="handleToNavMenu">
							<label class="icon iconfont">&#xe6a7;</label>
						</div>
					</div>
				</div>
			</div>
			<div class="nav-mask" v-show="navMenuDisplay">
				<div class="yd-nav">
					<div v-for="(item, index) of navList" :key="index">
						<a href="javascript:void(0);" :class="navActiveIndex == index ? 'h-nav-active':''" @click="handleToPage(item.url, index)">{{item.text}}</a>
					</div>
				</div>
			</div>
		</section>
		<keep-alive exclude="articleDetail">
    	<router-view @changeNavIndex="changeNavIndex"/>
		</keep-alive>
		<footer id="footer" class="f-footer display-flex align-item-center">
			<div class="container">
				<div class="row">
					<div class="col-xs-12 col-sm-8 col-md-8">
						<div class="f-title">联系方式</div>
						<div class="f-text iconfont" @click="makingACall('010-85181133')">&#xe606;&nbsp;&nbsp;电话：<a href="#" style="text-decoration: underline;">010-85181133</a></div>
						<div class="f-text iconfont">&#xe673;&nbsp;&nbsp;邮箱：yinzhijun@gaosilaw.com</div>
						<div class="f-text iconfont" @click="openMap('https://ditu.amap.com/search?id=B000A8ULE2&city=110102&geoobj=116.384925%7C39.878636%7C116.390993%7C39.881411&query_type=IDQ&query=%E5%AF%8C%E5%8A%9B%C2%B7%E6%91%A9%E6%A0%B9%E4%B8%AD%E5%BF%83E%E5%BA%A7&zoom=17.5')">&#xe665;&nbsp;&nbsp;地址：<a href="#" style="text-decoration: underline;">北京市西城区太平街6号富力摩根中心E座702</a></div>
						<div class="f-img-ewm">
							<img src="./assets/img/index/gaosi-ewm.png" style="vertical-align: middle;" alt="高思-二维码"/>
							高思律师事务所-公众号
						</div>
						<div class="f-text" style="margin-bottom:0;">京ICP备10215976号</div>
					</div>
					<div class="col-xs-12 col-sm-4 col-md-4" id="map" style="height:320px">
					</div>
				</div>
			</div>
		</footer>
  </div>
</template>

<script>
import AMap from 'AMap'
export default {
	name: 'App',
	data() {
		return {
			searchListDisplay: false,
			searchWords: '',
			searchData: [],
			slideMenuDisplay: false,
			navMenuDisplay: false,
			heixinUlWidth: 0,
			navList: [{
				url: '/', text: '首页'
			},{
				url: '/', text: '简介'
			},{
				url: '/', text: '资讯'
			},{
				url: '/', text: '业务'
			},{
				url: '/', text: '案例'
			},{
				url: '/', text: '团队'
			}],
			navActiveIndex: 0,
			headerFixed: false,
			interval: null,
			time: 0
		}
	},
	watch: {
		searchWords () {
			if (!this.searchWords) {
				this.searchListDisplay = false
			} else {
				this.searchListDisplay = true
			}
		},
		$route (to, from) {
			// console.log(to.name)
			// console.log(localStorage.getItem("ip"))
				//调用页面统计接口
			this.setPagePVUV()
			this.time = 0
			clearInterval(this.interval)
			this.interval = setInterval(() => {
				this.time = this.time + 1
			}, 1000);
		}
	},
	mounted () {
		if (this.$route.name == 'articleDetail') {
			this.navActiveIndex = 2
		} else {
			if (this.$route.query.flag) {
				this.navActiveIndex = this.$route.query.flag
			}
		}

		clearInterval(this.interval)
		this.interval = setInterval(() => {
			this.time = this.time + 1
		}, 1000);

		window.addEventListener("scroll",this.handleScroll)
		this.init()
	},
	destroyed () {
		document.removeEventListener('scroll', this.handleScroll)
	},
	methods: {
		openMap (position) {
			window.open(position)
		},
		makingACall (num) {
			window.location.href = 'tel://'+num
		},
		//pv、uv
		setPagePVUV () {
			this.axios.post('https://sys.qilinsports.com/law/sysvisitrecord',{
				browseLength: this.time, "ip": localStorage.getItem('ip')
			}).then((res) => {
				
			}).catch(function(error){
				console.log(error)//错误处理 相当于error
			})
		},
		handleToContentDetail (id) {
			this.searchListDisplay = false
			this.$router.push({ path: '/articleDetail', query: {id: id} })
		},
		noneSearchList () {
			this.searchListDisplay = false
		},
		searchByArticleTitle () {
			if (!this.searchWords) {
				return
			}
			this.axios.get('https://sys.qilinsports.com/law/sysarticle/search',{
				params: { keyword: this.searchWords },
			}).then((res) => {
				if (res.data.code == 0) {
					this.searchListDisplay = true
					this.searchData = res.data.data
				}
			}).catch(function(error){
				console.log(error)//错误处理 相当于error
			})
		},
		init () {
			var map = new AMap.Map('map', {
				center: [116.397428, 39.90923],
				resizeEnable: true,
				zoom: 10
			})
			var marker = new AMap.Marker({
					position: new AMap.LngLat(116.38829, 39.880806),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
					title: '北京'
			});
			AMap.plugin(['AMap.ToolBar', 'AMap.Scale'], function () {
				map.addControl(new AMap.ToolBar())
				map.addControl(new AMap.Scale())
				map.add(marker)
			})
    },
		handleScroll() {
			//获取滚动时的高度
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			if (this.$refs.headerNav) {
				if (scrollTop > this.$refs.headerNav.clientHeight) {
					this.headerFixed = true
				} else {
					this.headerFixed = false
				}
			}
    },
		handleToNavMenu () {
			this.navMenuDisplay = !this.navMenuDisplay
		},
		slideMenu (val) {
			this.slideMenuDisplay = val
		},
		handleToPage (url, index) {
			this.navActiveIndex = index
			this.$router.push({ path: url, query: {flag: index} })
			this.navMenuDisplay = false
		},
		changeNavIndex (index) {
			this.navActiveIndex = index
		}
	}
}
</script>

<style scoped>
@import url("./assets/css/main.css");
@import url("./assets/css/common.css");
</style>



// WEBPACK FOOTER //
// src/App.vue